import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";
import PromoView from "@/views/PromoView.vue";

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/promo",
    name: "promo",
    component: PromoView,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
